import { graphqlApolloClient } from "../graphql-apollo-client"
import { GET_BENEFICIARIES_BY_SUBMISSION } from "./graphql/queries/getBeneficiariesBySubmission"

export const getBeneficiariesBySubmission = async ({ id }) => {
  const { data } = await graphqlApolloClient.query({
    query: GET_BENEFICIARIES_BY_SUBMISSION,
    fetchPolicy: "network-only",
    variables: {
      id
    }
  })

  return data?.BeneficiariesBySubmission
}